import { Formik, Form } from 'formik';
import { initialValues, validationSchema_18809 } from 'blocks/Form/data/validation';
import FirstName from 'blocks/Form/fields/FirstName';
import LastName from 'blocks/Form/fields/LastName';
import Email from 'blocks/Form/fields/Email';
import Submit from 'blocks/Form/fields/Submit';
import EmployeeID from 'blocks/Form/fields/EmployeeID';
import ErgOfInterest from 'blocks/Form/fields/ErgOfInterest';
import ErgRegion from 'blocks/Form/fields/ErgRegion';
import EUComments from 'blocks/Form/fields/EUComments';

/* === CORP - Diversity === */

const Form18809 = ({ handleSubmit, isPending, language, fields }) => {
	const {
		first_name,
		last_name,
		email_address,
		employee_id,
		erg_of_interest,
		erg_region,
		why_is_diversity,
		submit,
		validation,
	} = fields;
	return (
		<Formik
			initialValues={initialValues}
			onSubmit={values => handleSubmit('marketo', values)}
			validationSchema={validationSchema_18809(validation)}
		>
			{formik => (
				<Form className='form form--lg'>
					<div className='grid-lg-2 row-gap-0'>
						<FirstName label={first_name} initialValues={initialValues} />
						<LastName label={last_name} initialValues={initialValues} />
						<Email label={email_address} initialValues={initialValues} />
						<EmployeeID label={employee_id} initialValues={initialValues} />
						<ErgOfInterest data={erg_of_interest} initialValues={initialValues} />
						<ErgRegion data={erg_region} initialValues={initialValues} />
					</div>
					<EUComments label={why_is_diversity} initialValues={initialValues} />
					<Submit
						formik={formik}
						isPending={isPending}
						pendingText={submit.submitting}
						validation={submit.all_required_fields}
					>
						{submit.submit}
					</Submit>
				</Form>
			)}
		</Formik>
	);
};

export default Form18809;
